'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ClosedMediaPlayer = require('./ClosedMediaPlayer');

var _ClosedMediaPlayer2 = _interopRequireDefault(_ClosedMediaPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ClosedMediaPlayer2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ClosedMediaPlayer/index.js
// module id = 562
// module chunks = 11